/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'react-feather';
import './access-denied.scss';
import Button from '../button';
import { getRenderIcon } from '../../../utils/general-utils';

const AccessDenied = ({ title, description, ...buttonProps }) => (
  <div className="access-denied-cont">
    <div className="ad-illustration" />
    <div className="ad-texts">
      <div className="ad-title">{title}</div>
      <div className="ad-message">
        {description}
      </div>
      <div className="ad-buttons">
        <Button renderIcon={getRenderIcon(ArrowLeft)} {...buttonProps} />
      </div>
    </div>
  </div>
);

AccessDenied.defaultProps = {
  description: '',
  buttonProps: {},
};

AccessDenied.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonProps: PropTypes.shape({}),
};

AccessDenied.defaultProps = {
  title: 'ACCESS_DENIED',
};

export default AccessDenied;
